var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadcamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.3182,
    y: 1.15473,
    width: 54.3587,
    height: 54.3587,
    rx: 14.7888,
    transform: "rotate(0.172581 1.3182 1.15473)",
    fill: "black",
    stroke: "url(#paint0_linear_5454_13066)",
    strokeWidth: 2.39818
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5454_13066",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 33,
    height: 32
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.7197,
    y: 12.2842,
    width: 31.1205,
    height: 31.1205,
    transform: "rotate(0.172581 12.7197 12.2842)",
    fill: "#D9D9D9",
    stroke: "#6C6C6C",
    strokeWidth: 0.338793
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5454_13066)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2436 24.7622C29.487 24.766 30.6783 25.2634 31.5548 26.1453C32.4313 27.0272 32.9216 28.2214 32.9179 29.4648C32.9141 30.7082 32.4168 31.8995 31.5349 32.7761C30.653 33.6527 29.4587 34.1428 28.2153 34.1391C26.9719 34.1354 25.7807 33.6379 24.904 32.7561C24.0275 31.8742 23.5373 30.68 23.541 29.4366C23.5447 28.1931 24.0421 27.0019 24.924 26.1253C25.8059 25.2487 27.0001 24.7585 28.2436 24.7622Z",
    fill: "white",
    stroke: "#6C6C6C",
    strokeWidth: 0.0441136
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8934 16.1075L31.8983 16.1286C32.3653 16.1302 32.8163 16.3486 33.4419 16.896C34.0677 17.4436 34.865 18.3173 36.0245 19.6235C36.2816 19.9071 36.6397 20.0746 37.0231 20.0757L41.488 20.0892C42.9172 20.0936 43.9612 21.1683 43.957 22.5898L43.9136 37.0087C43.9093 38.4327 42.8559 39.7113 41.4289 39.7072L15.2122 39.6283C13.7825 39.6238 12.4944 38.3353 12.4987 36.914L12.5421 22.4952C12.5465 21.0762 13.8397 20.0059 15.2801 20.0102L15.9168 20.0121L15.9188 19.3354C15.9199 18.9871 16.2053 18.7025 16.5535 18.7035L18.6834 18.7099C19.0317 18.711 19.3163 18.9973 19.3153 19.3456L19.3133 20.0224L19.6707 20.0235C20.0454 20.0246 20.4132 19.8678 20.6642 19.585L20.6632 19.5841C21.8344 18.2811 22.6559 17.4111 23.3032 16.8664C23.9506 16.3217 24.4219 16.1061 24.8934 16.1075ZM27.9213 22.4292C24.3129 22.5827 21.386 25.492 21.2107 29.0994C21.0094 33.2325 24.402 36.6448 28.5362 36.4682C32.1445 36.3146 35.0705 33.4062 35.2458 29.7989C35.4473 25.6658 32.0554 22.2529 27.9213 22.4292ZM36.114 22.6511C35.512 22.6493 35.0256 23.1327 35.0238 23.7348C35.0221 24.3368 35.5054 24.8231 36.1075 24.8249C36.7094 24.8266 37.1958 24.3432 37.1976 23.7413C37.1995 23.1393 36.7159 22.6531 36.114 22.6511Z",
    fill: "white",
    stroke: "#6C6C6C",
    strokeWidth: 0.0441136
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5454_13066",
    x1: 49.7027,
    y1: 2.35742,
    x2: 8.17635,
    y2: 52.0632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F90355"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511016,
    stopColor: "#F4057F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE5D30"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadcamera);
export default __webpack_public_path__ + "static/media/uploadcamera.664b849bf897784a9575ab616c53510e.svg";
export { ForwardRef as ReactComponent };